import i18n from "../../i18n";
import { Component } from "react";
import { captureException } from "../../utils/sentry";

/**
 * ErrorBoundary global.
 *
 * Empêche qu'une erreur de rendu React (composant qui « crash ») ne fasse
 * disparaître TOUTE l'application (écran blanc). En cas d'erreur, on affiche
 * un message de repli avec un bouton pour recharger la page, et on log l'erreur.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info && info.componentStack);
    // Remonte l'erreur de rendu à Sentry (sinon elle resterait invisible).
    try {
      captureException(error, {
        extra: { componentStack: info && info.componentStack },
      });
    } catch (e) {
      /* ignore */
    }
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== "undefined") window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-[60vh] w-full flex-col items-center justify-center px-6 text-center">
        <div className="max-w-md rounded-2xl border border-[#e8e3f1] bg-white p-8 shadow-sm">
          <h2 className="text-[18px] font-bold text-[#1f2330]">Une erreur est survenue</h2>
          <p className="mt-2 text-[13.5px] leading-relaxed text-[#5b5f6b]">{i18n.t("errorBoundary.auto.1", "Quelque chose s'est mal passé lors de l'affichage de cette page. Vous pouvez recharger la page ou revenir à l'accueil.")}</p>
          <div className="mt-5 flex flex-wrap justify-center gap-2">
            <button
              type="button"
              onClick={this.handleReload}
              className="rounded-full bg-[var(--brand,#976DD0)] px-5 py-2.5 text-[13px] font-semibold text-white"
            >
              Recharger la page
            </button>
            <a
              href="/"
              className="rounded-full border border-[#d9d9e6] px-5 py-2.5 text-[13px] font-semibold text-[#5b5f6b]"
            >{i18n.t("errorBoundary.auto.2", "Retour à l'accueil")}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
